import React from 'react';

const AvatarIcon: React.FC<{
  width?: string;
  height?: string;
  className?: string;
  fill?: string;
}> = ({ width = '16px', height = '16px', className, fill = '#D9D9D9' }): React.ReactElement => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8 0C12.4183 0 16 3.58172 16 8C16 12.4183 12.4183 16 8 16C3.58172 16 0 12.4183 0 8C0 3.58172 3.58172 0 8 0ZM8 1C4.13401 1 1 4.13401 1 8C1 10.0881 1.9143 11.9627 3.36441 13.2452C3.67048 11.7724 4.36145 10.4268 5.28708 9.52793L5.40909 9.41328L6.08163 10.1533C5.16276 10.9884 4.47653 12.3971 4.26145 13.9191C5.34307 14.6037 6.62525 15 8 15C9.37475 15 10.6569 14.6037 11.7385 13.9191C11.5235 12.3971 10.8372 10.9884 9.91837 10.1533L10.5909 9.41328L10.7129 9.52793C11.6386 10.4268 12.3295 11.7724 12.6356 13.2452C14.0857 11.9627 15 10.0881 15 8C15 4.13401 11.866 1 8 1ZM11 6.5C11 4.84315 9.65685 3.5 8 3.5C6.34315 3.5 5 4.84315 5 6.5C5 8.15685 6.34315 9.5 8 9.5C9.65685 9.5 11 8.15685 11 6.5ZM6 6.5C6 5.39543 6.89543 4.5 8 4.5C9.10457 4.5 10 5.39543 10 6.5C10 7.60457 9.10457 8.5 8 8.5C6.89543 8.5 6 7.60457 6 6.5Z"
        fill={fill}
      />
    </svg>
  );
};

export default AvatarIcon;
